import { TextField, ThemeProvider, createTheme } from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import FilterTable from "./FilterTable";
import ReactTable from "../blacklist/ReactTable";
// import { common_axios } from "../../..";
import { common_axios } from "../../../App";
import DeleteIcon from "@mui/icons-material/Delete";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import { withRouter } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import FilterListIcon from "@mui/icons-material/FilterList";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CheckIcon from "@mui/icons-material/Check";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import Swal from "sweetalert2";
import { stopState } from "../../../redux/features/pageSlices";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Pagination from "@mui/material/Pagination";
import {
  Stack,
} from "@mui/material";
const Deactivate = ({ deactiveData, deactivePageData, pageno, pagesize }) => {
  //.........useState..................//
  const [data, setData] = useState([]);
  const [disable, setDisable] = useState(true);
  const [stopApi, setStopApi] = useState(true);
  const [editDetails, seteditDetails] = useState();
  const [userEditState, setUserEditState] = React.useState([]);
  const [accountidvalue, setAccountIdValue] = useState([]);
  const [accountIdSkelton, setAccountIdSkelton] = useState(false);
  const [TableStatus, setTableStatus] = useState({
    // hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const [data1, setData1] = useState([]);
  const [paginationPage, setPaginationPage] = React.useState(1);

  useEffect(() => {
    setData(deactiveData);
    setData1(deactivePageData);
    setTableStatus({
      ...TableStatus,
      pageNo: pageno,
      pageSize: pagesize,
    });
  }, [deactiveData, deactivePageData]);

  const customId1 = "custom-id-yess";
  // ...................................Theme Provider....................................//

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
          // "&$error": {
          //   color: "#db3131",
          // },
        },
      },
    },
  });

  // .....................................Formik............................................//

  const initialValues = {
    keyword: "",
  };

  const validationSchema = yup.object({
    keyword: yup
      .string()
      .min(3, "Please enter atleast 3 characters in keyword")
      .max(90, "No more longer to 90 charcaters")
      .required("Required"),
  });

  const formik = useFormik({
    initialValues: initialValues,

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validationSchema: validationSchema,
    onSubmit: (values) => {
      //   FilterPost(values);
    },
  });

  // .......................................Get API.........................................//
  // console.log("data556", data);
  async function FilterGet() {
    setData([]);
    try {
      setOpen(true);

      const result = await common_axios.post(
        // `http://192.168.167.66:5002/v1/drools-rule/get-rules?pageNo=${pageNumber1}&pageSize=${PageSize1}`
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/get/all/keywords`,

        // status: "DND",
        // pageNo: "0",
        // pageSize: "10",

        // droolsReq: {
        //   pageNo: TableStatus?.pageNo,
        //   pageSize: TableStatus?.pageSize,
        //   status: false,
        // },
        {
          keywordRequest: {
            pageNo: TableStatus?.pageNo,
            pageSize: TableStatus?.pageSize,
            status: false,
          },
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        setData(result.data.keyWordResponse);
        setData1(result.data);
        setOpen(false);
      } else {
        setOpen(false);
        // toast.error(result.data.statusDescription.statusMessage, {
        //   toastId: customId1,
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  useEffect(() => {
    if (stopApi == false) {
      FilterGet();
    }
  }, [TableStatus.pageSize, TableStatus.pageNo]);

  // -----------------------------------Filter Table-------------------------------

  const [open, setOpen] = useState();
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [selectedUserDetailView, setSelectedUserDetailView] =
    useState(undefined);
  const [viewUsername, setViewUserName] = useState([]);

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);
  const modelView = useRef(null);
  const modelActDeactApprove = useRef(null);

  const ViewUserModal = async (cell) => {
    // console.log("cell--", cell.row.original);
    await setSelectedUserDetailView(cell.row.original);

    let temp = [];
    if (cell.row.original.userResponses.length > 0) {
      await setViewUserName(cell.row.original.userResponses);
    } else {
      temp.push({
        userId: "all",
        userName: "All",
      });
      await setViewUserName(temp);
    }
    // await setTop100Films(cell?.row?.original?.userContactList);
    await modelView.current.click();
  };
  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    let temp = [];
    if (cell.row.original.userResponses.length > 0) {
      await setViewUserName(cell.row.original.userResponses);
    } else {
      temp.push({
        userId: "all",
        userName: "All",
      });
      await setViewUserName(temp);
    }
    await modelButtonReject.current.click();
  };

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    seteditDetails(cell.row.original.keyword);
    let temp = [];
    if (cell.row.original.allFlag == false) {
      await setUserEditState(cell.row.original.userResponses);
    } else {
      temp.push({
        userId: "all",
        userName: "All",
      });
      await setUserEditState(temp);
    }
    await modelButtonApprove.current.click();
  };
  const [actDeactDetailApprove, setActDeactDetailApprove] = useState(undefined);
  const approveUserActDeact = async (cell) => {
    setActDeactDetailApprove(cell.row.original);
    modelActDeactApprove.current.click();
  };

  // .................................KEYWORD DELETE API...................................//
  const rejectUserApi = async (selectedUserDetail) => {
    // console.log("selectedUserDetail-----==", selectedUserDetail);
    try {
      setOpen(true);
      const deleteResponse = await common_axios.post(
        // "http://192.168.167.66:5002/v1/drools-rule/delete",
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/delete/keywords`,
        {
          keywordRequest: {
            keyword: selectedUserDetail.keyword,
          },
        }
      );
      // console.log("deleteResponse--------", deleteResponse);
      if (deleteResponse.data.statusDescription.statusCode == 200) {
        setOpen(false);
        FilterGet();
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Keyword deleted successfully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: deleteResponse.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      setOpen(false);
    }
  };
  //..............................Keyword Update API...............................//
  const [modifiedState, setModifiedState] = useState(false);

  const approveUserApi = async (values) => {
    // let updateId = userEditState?.map((e) => e?.userId);

    // console.log("values-----", updateId);

    let userIds = [];
    for (let i = 0; i < userEditState.length; i++) {
      if (userEditState[i].userId != "all") {
        userIds[i] = userEditState[i].userId;
      }
    }

    // if (error == false) {
    //    const butt = document.getElementById("getcancel");
    // butt.click();
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/update/keywords`,

        // `http://192.168.167.66:5002/v1/update/DND/msisdn`,
        {
          // id: userid,
          // // msisdn: number,
          // msisdn: phoneNumber1,
          keywordRequest: {
            oldKeyWord: selectedUserDetailApprove?.keyword,
            modifiedBy: localStorage.getItem("usernamedisplayed"),
            // msisdn:"222"+ phoneNumber1,
            // uid: updateId?.includes("all") ? null : updateId,
            // allFlag: updateId?.includes("all") ? true : false,
            userId:
              JSON.parse(localStorage.getItem("Sidebaritems")).name ==
              "ROLE_SUPER_ADMIN"
                ? userIds?.length > 0
                  ? userIds
                  : null
                : [JSON.parse(localStorage.getItem("items")).userId],
            // allFlag: false,
            // allFlag: userIds.includes("all") ? true : false,
            allFlag: userIds?.length > 0 ? false : true,
            status: selectedUserDetailApprove.status,
          },
        }
      );
      // console.log("update res----=", res);
      if (res.data.statusDescription.statusCode == 200) {
        // setCheckModal("modal")
        // console.log("dsghv",)
        setOpen(false);

        FilterGet();

        // formik.setFieldValue("msisdn",phoneNumber1)
        // UpdateGet();
        setModifiedState(true);
        //  SearchPost1(values);
        // SearchPost()
        // await toast.success("Mobile number updated successfully", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Keyword updated successfully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        // SearchPost();
      }
      // else if (result.data.statusDescription.statusCode == 202) {
      //   toast.error("Mobile number already exists !!", {
      //     theme: "colored",
      //   });
      //   setOpen(false);
      // }
      else if (res.data.statusDescription.statusCode == 202) {
        // toast.error("Mobile number is already exist!");
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Keyword is already exist!",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setOpen(false);
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescription.statusdescription, {
        //   toastId: customId1,
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // }
  };

  //  ..........................Status Update API...................................//

  const [changeStatus, setChangeStatus] = useState("");

  const ActivateDeactivateStatus = async (actDeactDetailApprove) => {
    // if (actDeactDetailApprove.response == true) {
    //   setChangeStatus(false);
    // } else {
    //   setChangeStatus(true);
    // }
    try {
      setOpen(true);
      const UpdateResponse = await common_axios.post(
        // "http://192.168.167.66:5002/v1/drools-rule/keyword/update-status"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/keword/activate/deactivate`,
        {
          keywordRequest: {
            keyword: actDeactDetailApprove.keyword,
            id: actDeactDetailApprove.id,
            status: true,
          },
        }
      );
      // console.log("UpdateResponse--------", UpdateResponse);
      if (UpdateResponse.data.statusDescription.statusCode == 200) {
        setOpen(false);
        FilterGet();
        const butt = document.getElementById("home-tab2");
        butt.click();
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Keyword updated successfully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: UpdateResponse.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      setOpen(false);
    }
  };

  // ---------------------------Account id---------------------------------------------------------------------
  async function AccountId() {
    // console.log("first");
    setAccountIdSkelton(true);
    try {
      // setHideSkeleton1(true);
      const result = await common_axios(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get/user/data`
      );
      if (result.data.statusDescription.statusCode == 200) {
        // setHideSkeleton1(false);
        let x = [
          {
            userId: "all",
            userName: "All",
          },
        ];
        let temp = [...x, ...result.data.accountId];
        // temp.push({
        //   userId: 0,
        //   userName: "All",
        // });
        setAccountIdValue(temp);
        setAccountIdSkelton(false);

        // setAccountIdValue(result.data.accountId);
      } else {
        // setHideSkeleton1(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setAccountIdSkelton(false);
      }
    } catch (error) {
      setAccountIdSkelton(false);
      // setOpen(false);
      // setHideSkeleton1(false);
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      //  });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
      "ROLE_SUPER_ADMIN"
    ) {
      AccountId();
    }
  }, []);
  // ----------------------------------------------------------------------------------------------------------
  const x = 2;

  const columns = useMemo(
    () =>
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
      "ROLE_SUPER_ADMIN"
        ? [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => (
                <>
                  {cell.row.index +
                    1 +
                    TableStatus?.pageNo * TableStatus?.pageSize}
                </>
              ),
            },

            {
              Header: "Keyword",
              Footer: "Keyword",
              accessor: "keyword",
            },
            {
              Header: "Created By",
              accessor: "createdBy",
            },
            {
              Header: "Created Date",
              // Footer: "Status",
              accessor: "createdDate", // accessor is the "key" in the data
            },

            {
              Header: "Status",
              Footer: "Status",
              accessor: "status",
              Cell: (cell) => (
                <div className="">
                  <button
                    className="btn color_1 w-auto cursor_Normal"
                    type="button"
                    id="dropdownMenuButton1"
                    aria-expanded="false"
                  >
                    {/* {console.log("cell111", cell)} */}
                    {cell.row.original.status == false ? (
                      <>
                        <span class="badge bg-danger activated_1">
                          Deactivated
                        </span>
                      </>
                    ) : (
                      <>
                        <span class="badge bg-success activated_1  w-auto">
                          Activated
                        </span>
                      </>
                    )}

                    {/* <DeleteIcon /> */}
                  </button>
                </div>
              ),

              disableFilters: true,
            },

            {
              Header: "Action",
              Footer: "Action",
              accessor: "action",
              Cell: (cell) => (
                <div className="dropdown">
                  <button
                    className="btn color_1 dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="material-icons opacity-10 size">person</i>
                    {/* <DeleteIcon /> */}
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li
                      onClick={() => {
                        // console.log(cell);
                      }}
                    >
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          rejectUserModal(cell);
                        }}
                      >
                        <DeleteIcon className="color_red_UP me-2" />
                        Delete
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          ViewUserModal(cell);
                        }}
                      >
                        <RemoveRedEyeIcon className="color_blue2_UP me-2" />
                        View Details
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          approveUserModal(cell);
                        }}
                      >
                        <EditIcon className="color_Green_UP me-2" />
                        Edit Details
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          approveUserActDeact(cell);
                        }}
                      >
                        {/* {cell.row.original.response == false ? (
                        <>
                          <RemoveCircleOutlineIcon />
                          Deactivate
                        </>
                      ) : (
                        <>
                          <CheckIcon />
                          Activate
                        </>
                      )} */}
                        <CheckIcon className="me-2" />
                        Activate
                      </a>
                    </li>
                  </ul>
                </div>
              ),

              disableFilters: true,
            },
          ]
        : [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => (
                <>
                  {cell.row.index +
                    1 +
                    TableStatus?.pageNo * TableStatus?.pageSize}
                </>
              ),
            },

            {
              Header: "Keyword",
              Footer: "Keyword",
              accessor: "keyword",
            },
            {
              Header: "Created By",
              accessor: "createdBy",
            },

            {
              Header: "Status",
              Footer: "Status",
              accessor: "response",
              Cell: (cell) => (
                <div className="">
                  <button
                    className="btn color_1 w-auto "
                    type="button"
                    id="dropdownMenuButton1"
                    aria-expanded="false"
                  >
                    {/* {console.log("cell111", cell)} */}
                    {cell.row.original.status == false ? (
                      <>
                        <span class="badge bg-danger activated_1">
                          Deactivated
                        </span>
                      </>
                    ) : (
                      <>
                        <span class="badge bg-success activated_1  w-auto">
                          Activated
                        </span>
                      </>
                    )}

                    {/* <DeleteIcon /> */}
                  </button>
                </div>
              ),

              disableFilters: true,
            },
            {
              Header: "Action",
              accessor: "action",
              Cell: (cell) =>
                cell.row.original.createdUserId ==
                localStorage.getItem("UserId") ? (
                  <>
                    <div className="dropdown">
                      <button
                        className="btn color_1 dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="material-icons opacity-10 size">person</i>
                        {/* <DeleteIcon /> */}
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li
                          onClick={() => {
                            // console.log(cell);
                          }}
                        >
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              rejectUserModal(cell);
                            }}
                          >
                            <DeleteIcon />
                            Delete
                          </a>
                        </li>
                        {/* <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          approveUserModal(cell);
                        }}
                      >
                        <EditIcon />
                        Edit Details
                      </a>
                    </li> */}
                        {/* <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          approveUserActDeact(cell);
                        }}
                      >
                        <RemoveCircleOutlineIcon />
                          Deactivate
                        
                      </a>
                    </li> */}
                      </ul>
                    </div>
                  </>
                ) : (
                  <>Not Allowed</>
                ),

              disableFilters: true,
            },
            // {
            //   Header: "Action",
            //   Footer: "Action",
            //   accessor: "action",
            //   Cell: (cell) => (
            //     <div className="dropdown">
            //       <button
            //         className="btn color_1 dropdown-toggle"
            //         type="button"
            //         id="dropdownMenuButton1"
            //         data-bs-toggle="dropdown"
            //         aria-expanded="false"
            //       >
            //         <i className="material-icons opacity-10 size">person</i>
            //         {/* <DeleteIcon /> */}
            //       </button>
            //       <ul
            //         className="dropdown-menu"
            //         aria-labelledby="dropdownMenuButton1"
            //       >
            //         <li
            //           onClick={() => {
            //             // console.log(cell);
            //           }}
            //         >
            //           <a
            //             className="dropdown-item"
            //             onClick={() => {
            //               rejectUserModal(cell);
            //             }}
            //           >
            //             <DeleteIcon />
            //             Delete
            //           </a>
            //         </li>
            //         {/* <li>
            //           <a
            //             className="dropdown-item"
            //             onClick={() => {
            //               approveUserModal(cell);
            //             }}
            //           >
            //             <EditIcon />
            //             Edit Details
            //           </a>
            //         </li> */}
            //         {/* <li>
            //           <a
            //             className="dropdown-item"
            //             onClick={() => {
            //               approveUserActDeact(cell);
            //             }}
            //           >

            //             <CheckIcon />
            //                 Activate
            //           </a>
            //         </li> */}
            //       </ul>
            //     </div>
            //   ),

            //   disableFilters: true,
            // },
          ],
    [TableStatus]
  );

  // const columns = useMemo(
  //   () => [
  //     {
  //       Header: "Id",
  //       accessor: "id",
  //       Cell: (cell ) => (
  //        <> {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}</>
  //       ),
  //     },

  //     {
  //       Header: "Keyword",
  //       Footer: "Keyword",
  //       accessor: "keyword",
  //     },
  //     {
  //       Header: "Created Date",
  //       // Footer: "Status",
  //       accessor: "createdDate", // accessor is the "key" in the data
  //     },

  //     {
  //       Header: "Status",
  //       Footer: "Status",
  //       accessor: "response",
  //       Cell: (cell) => (
  //         <div className="">
  //           <button
  //             className="btn color_1 w-auto px-0"
  //             type="button"
  //             id="dropdownMenuButton1"
  //             aria-expanded="false"
  //           >
  //             {/* {console.log("cell111", cell)} */}
  //             {cell.row.original.response == true ? (
  //               <>
  //                 <span class="badge bg-danger activated_1 w-auto">Deactivated</span>
  //               </>
  //             ) : (
  //               <>
  //                 <span class="badge bg-success activated_1  w-auto">Activated</span>
  //               </>
  //             )}

  //             {/* <DeleteIcon /> */}
  //           </button>
  //         </div>
  //       ),

  //       disableFilters: true,
  //     },

  //     {
  //       Header: "Action",
  //       Footer: "Action",
  //       accessor: "action",
  //       Cell: (cell) => (
  //         <div className="dropdown">
  //           <button
  //             className="btn color_1 dropdown-toggle"
  //             type="button"
  //             id="dropdownMenuButton1"
  //             data-bs-toggle="dropdown"
  //             aria-expanded="false"
  //           >
  //             <i className="material-icons opacity-10 size">person</i>
  //             {/* <DeleteIcon /> */}
  //           </button>
  //           <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
  //             <li
  //               onClick={() => {
  //                 console.log(cell);
  //               }}
  //             >
  //               <a
  //                 className="dropdown-item"
  //                 onClick={() => {
  //                   rejectUserModal(cell);
  //                 }}
  //               >
  //                 <DeleteIcon />
  //                 Delete
  //               </a>
  //             </li>
  //             {/* <li>
  //               <a
  //                 className="dropdown-item"
  //                 onClick={() => {
  //                   approveUserModal(cell);
  //                 }}
  //               >
  //                 <EditIcon />
  //                 Edit Details
  //               </a>
  //             </li> */}
  //             <li>
  //               <a
  //                 className="dropdown-item"
  //                 onClick={() => {
  //                   approveUserActDeact(cell);
  //                 }}
  //               >
  //                 {/* {console.log("cell-----", cell)} */}
  //                 {cell.row.original.response == false ? (
  //                   <>
  //                     {/* {alert("if")} */}
  //                     <RemoveCircleOutlineIcon  />
  //                     Deactivate
  //                   </>
  //                 ) : (
  //                   <>
  //                     {/* {alert("else")} */}
  //                     <CheckIcon />
  //                     Activate
  //                   </>
  //                 )}

  //                 {/* <EditIcon />
  //                 ACtivate */}
  //               </a>
  //             </li>
  //           </ul>
  //         </div>
  //       ),

  //       disableFilters: true,
  //     },
  //   ],
  //   [TableStatus]
  // );

  // console.log(Status, "lalalaallalas");

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;
  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <div>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        {/* ......................................................... */}

        {data.length > 0 ? (
          <>
            <div className="container-fluid">
              {/* <!-- <h6 className="font-weight-bolder mb-4">Add Source Masking Details.</h6> --> */}
              <div className="row">
                <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
                  {/* <div className="card mb-3 mt-4"> */}

                  <ThemeProvider theme={theme}>
                    {/* --------------------------------------------- */}

                    <div className="tab-content" id="myTabContent">
                      {/* .................................................................... */}
                      {/* ................................................................ */}
                      <div className="container-fluid p-0">
                        <div className="card shadow-none border bg_blue mt-5">
                          <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
                            Existing Spam Keyword List
                          </span>

                          <div className="p-4">
                            <div className="d-flex justify-content-between my-3">
                              <select
                                value={TableStatus.pageSize}
                                className="dropdown"
                                onChange={(e) => {
                                  setStopApi(false);
                                  setPageSize(Number(e.target.value));
                                  setTableStatus({
                                    ...TableStatus,
                                    pageSize: e.target.value,
                                    pageNo: 0,
                                  });
                                }}
                              >
                                {[10, 25, 50].map((value, i) => {
                                  return (
                                    <option
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                      value={value}
                                      key={value}
                                    >
                                      Show {value}
                                    </option>
                                  );
                                })}
                              </select>
                              {/* <div className="d-flex align-items-center">
                                <span className="d-block">Search</span>

                                <TextField
                                  className="ms-4 w-100"
                                  style={{
                                    borderRadius: "4px",
                                  }}
                                  type="text"
                                  label="Search"
                                  name="Search"
                                  variant="outlined"
                                  // value={number}
                                  size="small"
                                  value={globalSearchValue || ""}
                                  onChange={(e) => {
                                    onChange(e.target.value);
                                    setGlobalSearchValue(e.target.value);
                                  }}
                                />
                                
                              </div> */}
                            </div>

                            <div>
                              {selectedFlatRows.length > 0 && (
                                <button onClick={deletUser}>
                                  Delete Users
                                </button>
                              )}

                              {/* <button onClick={changeOrder}>Change Order</button> */}
                            </div>
                            <div class="table_overFlow">
                              <table
                                {...getTableProps()}
                                id="example"
                                className="table table-striped table-bordered dataTable table-sm"
                                style={{ width: "100%" }}
                              >
                                <thead>
                                  {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                      {headerGroup.headers.map((column) => (
                                        <th
                                          {...column.getHeaderProps(
                                            column.getSortByToggleProps()
                                          )}
                                          className="text-center width_2"
                                        >
                                          {column.render("Header")}
                                          <span>
                                            {column.isSorted
                                              ? column.isSortedDesc
                                                ? "↑"
                                                : "↓"
                                              : ""}
                                          </span>
                                        </th>
                                      ))}
                                    </tr>
                                  ))}
                                </thead>
                                <tbody class='onhover_change' id="tbody_8" {...getTableBodyProps()}>
                                  {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                      <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                          return (
                                            <td
                                              {...cell.getCellProps()}
                                              className={
                                                cell.column.Header == "Id"
                                                  ? "text-end"
                                                  : cell.column.Header ==
                                                      "Status" ||
                                                    cell.column.Header ==
                                                      "Action"
                                                  ? "text-center"
                                                  : "text-start"
                                              }
                                              // className="text-center"
                                            >
                                              {cell.render("Cell")}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                            <div className="d-flex justify-content-between">
                              <div>
                                <span>
                                  Page:
                                  <strong>
                                    {data1?.pageNumber + 1} of{" "}
                                    {data1?.totalPage}
                                  </strong>
                                </span>
                             
                              </div>
                              <div className="prev_next d-flex align-items-center">
                <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      //  disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                       
                        setTableStatus({
                          ...TableStatus,
                          pageNo:0,
                        });
                        setPaginationPage(1)
                      }}
                    >
                      First
                    </button>

                <Stack spacing={2}>
              <Pagination
                onChange={(event, value) => {
                  console.log("va--", value);
                  setTableStatus({
                    ...TableStatus,
                    pageNo: Number(value) - 1,
                  });
                  setPaginationPage(value);
                }}
                page={paginationPage}
                count={data1? data1?.totalPages : ""}
               
                variant="outlined"
                shape="rounded"
                
            color="primary"
              />
            </Stack>
            <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      // disabled={
                      //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                      //  }
                      onClick={() => {
                        // alert("gg")
                        setTableStatus({
                                   ...TableStatus,

                         pageNo:data1?.totalPages -1 ,
                        });
                        setPaginationPage(data1?.totalPages)

                      }}
                    >
                      Last
                    </button>
                
              </div>



{/* 
                              <div className="btn_n800">
                                <button
                                  className="btn btn_primary "
                                  type="button"
                                  style={{ background: "#2C97D4" }}
                                  disabled={data1?.pageNumber == 0}
                                  onClick={() => {
                                    setStopApi(false);
                                    setTableStatus({
                                      ...TableStatus,
                                      pageNo: TableStatus.pageNo - 1,
                                    });
                                  }}
                                >
                                  Prev
                                </button>

                                <button
                                  className="btn btn_primary ms-2"
                                  type="button"
                                  style={{ background: "#2C97D4" }}
                                  disabled={
                                    data1?.totalPage == data1?.pageNumber + 1
                                  }
                                  onClick={() => {
                                    setStopApi(false);
                                    setTableStatus({
                                      ...TableStatus,
                                      pageNo: TableStatus.pageNo + 1,
                                    });
                                  }}
                                >
                                  Next
                                </button>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ---------------------------------------------------- */}
                  </ThemeProvider>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* <div className="text-center mt-4">
                            {data?.length == 0 && open ? null : (
                              <h5 className="text-center mt-4">
                                No Record Found..!!
                              </h5>
                            )}
                          </div> */}
            <div className="text-center mt-4">
              {data?.length == 0 && open == true ? null : data?.length == 0 &&
                open == undefined ? null : (
                <div className="text-center">
                  <h5>No Record Found..!!</h5>
                </div>
              )}
            </div>
          </>
        )}
      </main>
      {/* -------------------------------------------------------------------------- */}

      {/* <div style={{ marginLeft: "260px" }}>
        {selectedUserDetail != undefined && (
          <div>
            <button
              ref={modelButtonReject}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Are you sure to delete?
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <TextField
                      disabled
                      className="ms-4 w-50  "
                      style={{
                        borderRadius: "4px",
                        marginTop: "10px",
                      }}
                      type="text"
                      label="Keyword"
                      name="rules"
                      variant="outlined"
                      size="small"
                      value={selectedUserDetail.rules}

                    />
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary delete_1"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        rejectUserApi(selectedUserDetail);
                      }}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary w_btn"
                      data-bs-dismiss="modal"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {selectedUserDetailApprove != undefined && (
          <div>
            <button
              ref={modelButtonApprove}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop1"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop1"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdrop1Label"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdrop1Label">
                
                      Update Details
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <TextField
                      className="ms-4 w-50  "
                      style={{
                        borderRadius: "4px",
                        marginTop: "10px",
                      }}
                      type="text"
                      label="Enter Keyword"
                      name="rules"
                      variant="outlined"
                      size="small"
                      value={editDetails}
                      onChange={(e) => {
                        seteditDetails(e.target.value);
                      }}
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary editcolor"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        approveUserApi(selectedUserDetailApprove);
                      }}
                    >
                      Ok
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary w_btn"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div> */}

      {/* {selectedUserDetailApprove != undefined && ( */}
      <div>
        <button
          ref={modelButtonApprove}
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop1"
        >
          Launch static backdrop modal
        </button>

        <div
          className="modal fade"
          id="staticBackdrop1"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdrop1Label"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content " style={{ width: "112%" }}>
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdrop1Label">
                  Update Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body row">
                <div className="col-md-5 my-auto">
                  <TextField
                    disabled
                    className="ms-4 "
                    style={{
                      borderRadius: "4px",
                      marginTop: "10px",
                      width: "90%",
                      // padding: "5.5px 14px"
                    }}
                    type="text"
                    label="Enter Keyword"
                    name="rules"
                    variant="outlined"
                    size="small"
                    value={editDetails}
                    onChange={(e) => {
                      seteditDetails(e.target.value);
                    }}
                  />
                </div>
                {accountIdSkelton == true ? (
                  <>
                    <Box sx={{ width: 270 }}>
                      <Skeleton />
                      <Skeleton animation="wave" />
                    </Box>
                  </>
                ) : (
                  <>
                    <div className="col-md-7 user_name_list mt-3">
                      <Autocomplete
                        required
                        size="small"
                        fullWidth
                        value={userEditState}
                        onChange={(e, val) => {
                          setUserEditState(val);
                        }}
                        multiple
                        limitTags={2}
                        id="multiple-limit-tags"
                        options={accountidvalue}
                        isOptionEqualToValue={(option, value) =>
                          option.userName === value.userName
                        }
                        getOptionDisabled={(option) =>
                          userEditState?.[0]
                            ? userEditState?.[0]?.userName === "All"
                              ? option.userName !== "All"
                              : option.userName === "All"
                            : null
                        }
                        getOptionLabel={(option) => option?.userName}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            fullWidth
                            {...params}
                            label="User Name List"
                          />
                        )}
                      />
                      {userEditState?.length == 0 && (
                        <>
                          <div>
                            <label style={{ color: "red" }}>
                              User name list is mandatory Field
                              <span>*</span>
                            </label>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer justify-content-between">
                {/* <div className="row"> */}
                {/* <div className="col-md-12 text-center"> */}
                <button
                  type="button"
                  className="btn btn-secondary ms-3 shadow"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  disabled={userEditState?.length == 0}
                  type="button"
                  className="btn btn-primary editcolor"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    approveUserApi(selectedUserDetailApprove);
                  }}
                >
                  Update
                </button>

                {/* </div> */}
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}

      {JSON.parse(localStorage.getItem("Sidebaritems")).name ==
      "ROLE_SUPER_ADMIN" ? (
        <>
          {" "}
          {/* {selectedUserDetail != undefined && ( */}
          <div>
            <button
              ref={modelButtonReject}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modaldialog_2">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Are you sure you want to delete?
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <form onSubmit={rejectUserApi}>
                    <div class="modal-body">
                      <div>
                        <div class="row justify-content-cente">
                          <div class="col-md-8 mt_2">
                            <div className="d-flex align-items-center">
                              {/* <div className="col-12 text-center "> */}
                              <label
                                for="exampleInputEmail1"
                                className="form-label m-0 me-2"
                              >
                                Keyword:
                              </label>
                              {/* </div> */}
                              <input
                                disabled
                                className="form-control"
                                placeholder="Keyword"
                                type="text"
                                minLength="3"
                                // value={selectedUserDetail?.dltId}
                                value={selectedUserDetail?.keyword}
                              />
                            </div>
                          </div>
                          <div className="table-responsive mt-4">
                            <table className="table table-striped table-bordered dataTable table-sm">
                              <thead>
                                <tr role="row">
                                  <th className="text-center width_2">
                                    UserName
                                  </th>
                                  {/* <th className="text-center width_2">
                                                        mobileNumber
                                                      </th> */}
                                </tr>
                              </thead>
                              <tbody class='onhover_change' id="dropdown-item" role="rowgroup">
                                {viewUsername?.map((arg) => {
                                  return (
                                    <>
                                      <tr role="row">
                                        <td style={{ fontSize: "13px" }}>
                                          {arg?.userName}
                                        </td>
                                        {/* <td>
                                                                {
                                                                  arg?.mobileNumber
                                                                }
                                                              </td> */}
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer justify-content-between">
                      {/* <div className="row"> */}
                      {/* <div className="col-md-12 text-center"> */}
                      <button
                        type="button"
                        className="btn btn-secondary ms-3 shadow"
                        data-bs-dismiss="modal"
                      >
                        No
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger"
                        data-bs-dismiss="modal"
                        onClick={() => {
                          rejectUserApi(selectedUserDetail);
                        }}
                      >
                        Delete
                      </button>

                      {/* </div> */}
                      {/* </div> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* )} */}
        </>
      ) : (
        <>
          {" "}
          {/* {selectedUserDetail != undefined && ( */}
          <div>
            <button
              ref={modelButtonReject}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modaldialog_2">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Are you sure you want to delete?
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <form onSubmit={rejectUserApi}>
                    <div class="modal-body">
                      <div>
                        <div class="row justify-content-cente">
                          <div class="col-md-6 mt_2">
                            <div className="d-flex align-items-center">
                              {/* <div className="col-12 text-center "> */}
                              <label
                                for="exampleInputEmail1"
                                className="form-label m-0 me-2"
                              >
                                Keyword:
                              </label>
                              {/* </div> */}
                              <input
                                disabled
                                className="form-control"
                                placeholder="Keyword"
                                type="text"
                                minLength="3"
                                // value={selectedUserDetail?.dltId}
                                value={selectedUserDetail?.keyword}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer justify-content-between">
                      {/* <div className="row"> */}
                      {/* <div className="col-md-12 text-center"> */}
                      <button
                        type="button"
                        className="btn btn-secondary ms-3 shadow"
                        data-bs-dismiss="modal"
                      >
                        No
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger"
                        data-bs-dismiss="modal"
                        onClick={() => {
                          rejectUserApi(selectedUserDetail);
                        }}
                      >
                        Delete
                      </button>

                      {/* </div> */}
                      {/* </div> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* )} */}
        </>
      )}

      {/* {selectedUserDetailApprove != undefined && ( */}
      {/* <div>
          <button
            ref={modelButtonApprove}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop1"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdrop1Label"
            aria-hidden="true"
          >
            <div className="modal-dialog modaldialog_2">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdrop1Label">
                    Update Details
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row justify-content-center">
                    <div className="col-md-6 mt_2">
                      <div class="col-12 text-center px-0">
                        <label for="exampleInputEmail1" className="form-label">
                          Keyword:
                        </label>
                      </div>
                      <input
                      disabled
                        type="text"
                        value={editDetails}
                        onChange={(e) => {
                          seteditDetails(e.target.value);
                        }}
                        className="form-control select_5"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>
                </div>

                <div className="modal-footer justify-content-between">
                <button
                    type="button"
                    className="btn btn-secondary shadow"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary editcolor shadow okbtn"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      approveUserApi(selectedUserDetailApprove);
                    }}
                  >
                    Update
                  </button>
                  
                </div>
              </div>
            </div>
          </div>
        </div> */}
      {/* )} */}
      {/* {actDeactDetailApprove != undefined && ( */}
      <div>
        <button
          ref={modelActDeactApprove}
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop4"
        >
          Launch static backdrop modal
        </button>

        <div
          className="modal fade"
          id="staticBackdrop4"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdrop4Label"
          aria-hidden="true"
        >
          <div className="modal-dialog modaldialog_2">
            <div className="modal-content">
              <div className="modal-header">
                {/* {actDeactDetailApprove?.response == false ? (
                  <> */}
                {/* <h5 className="modal-title" id="staticBackdrop2Label">
                      Are you sure want to deactivate
                    </h5> */}
                {/* </>
                ) : (
                  <> */}
                <h5 className="modal-title" id="staticBackdrop4Label">
                  Are you sure you want to activate?
                </h5>
                {/* </>
                )} */}

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              {/* <div className="modal-body">
                <div className="row justify-content-center">
                  <div className="col-md-6 mt_2">
                    <div class="col-12 text-center px-0">
                      
                      <label for="exampleInputEmail1" className="form-label">
                        Keyword:
                      </label>
                    </div>
                    <input
                      type="text"
                      value={editDetails}
                      onChange={(e) => {
                        seteditDetails(e.target.value);
                      }}
                    
                      className="form-control select_5"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>
              </div> */}

              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary shadow"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary editcolor shadow okbtn"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    // alert("kkk")
                    ActivateDeactivateStatus(actDeactDetailApprove);
                  }}
                >
                  Activate
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}

      {/* {selectedUserDetailView != undefined && ( */}
      <div>
        <button
          ref={modelView}
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop18"
        >
          Launch static backdrop modal
        </button>

        <div
          className="modal modal_talble fade"
          id="staticBackdrop18"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdrop18Label"
          aria-hidden="true"
        >
          <div className="modal-dialog modaldialog_2">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdrop18Label">
                  View Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  // onClick={RemovePhoneBook}
                ></button>
              </div>
              <div
                className="modal-body"
                style={{
                  height: "auto",
                  overflow: "auto",
                }}
              >
                <div>
                  <div class="row justify-content-cente">
                    <div class="col-md-8 mt_2">
                      <div className="d-flex align-items-center">
                        <label
                          for="exampleInputEmail1"
                          className="form-label m-0 me-2"
                        >
                          Keyword:
                        </label>
                        {/* </div> */}
                        <input
                          disabled
                          className="form-control m-0 w-100"
                          placeholder="Keyword"
                          type="text"
                          minLength="3"
                          // value={selectedUserDetail?.dltId}
                          value={selectedUserDetailView?.keyword}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive mt-4">
                  <table className="table table-striped table-bordered dataTable table-sm">
                    <thead>
                      <tr role="row">
                        <th className="text-center width_2">UserName</th>
                        {/* <th className="text-center width_2">
                                                        mobileNumber
                                                      </th> */}
                      </tr>
                    </thead>
                    <tbody class='onhover_change' id="dropdown-item" role="rowgroup">
                      {viewUsername?.map((arg) => {
                        return (
                          <>
                            <tr role="row">
                              <td
                                className="text-start"
                                style={{ fontSize: "13px" }}
                              >
                                {arg?.userName}
                              </td>
                              {/* <td>
                                                                {
                                                                  arg?.mobileNumber
                                                                }
                                                              </td> */}
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
    </>
  );
};

export default withRouter(Deactivate);
